import React from 'react';

import './handlers.js';
import './subs';
import BetbookRoot from './views/BetbookRoot';
import { BetbookPosts } from './views/BetbookPosts';
import { registerPopup } from '@/ui/popupRegistrar';
import BetbookPostMoreOptionsDialog from './views/BetbookPostMoreOptionsDialog';
import BetbookPostReportDialog from './views/BetbookPostReportDialog';
import BetbookSearchDialog from './views/BetbookSearchDialog';
import BetbookSearchDetailedBetsDialog from './views/BetbookSearchDetailedBetsDialog';
import BetbookCommentsMoreOptionsDialog from './views/BetbookCommentsMoreOptionsDialog';
import BetbookCommentsReportDialog from './views/BetbookCommentsReportDialog';
import BetbookPostsModule from './views/BetbookPostsModule';
import EditorWithComments from '@/betbook/views/EditorWithComments';
import BetbookProfileDialog from '@/betbook/components/betbook-profile-dialog/BetbookProfileDialog';
import BetbookLobby from '@/betbook/views/BetbookLobby';
import BetbookPostsDialog from '@/betbook/views/BetbookPostsDialog';
import BetbookStatisticsDialog from '@/betbook/views/BetbookStatisticsDialog';
import HomePageBetbookPosts from '@/betbook/views/HomePageBetbookPosts';
import MatchBetbookPosts from '@/betbook/views/MatchBetbookPosts';
import BetbookInfoDialog from '@/betbook/views/BetbookInfoDialog';

registerPopup('betbook/postOptions', popup => <BetbookPostMoreOptionsDialog {...popup.get('data')} />);
registerPopup('betbook/postReport', popup => <BetbookPostReportDialog {...popup.get('data')} />);
registerPopup('betbook/searchDialog', () => <BetbookSearchDialog />);
registerPopup('betbook/searchDetailedBetsDialog', popup => {
    const { sportEventId, forceBetSelection } = popup.get('data');
    return <BetbookSearchDetailedBetsDialog sportEventId={sportEventId} forceBetSelection={forceBetSelection} />;
});
registerPopup('betbook/commentsOptions', popup => <BetbookCommentsMoreOptionsDialog {...popup.get('data')} />);
registerPopup('betbook/commentsReport', popup => <BetbookCommentsReportDialog {...popup.get('data')} />);
registerPopup('betbook/profileDialog', popup => <BetbookProfileDialog {...popup.get('data')} />);
registerPopup('betbook/postsDialog', popup => <BetbookPostsDialog {...popup.get('data')} />);
registerPopup('betbook/statisticsDialog', popup => <BetbookStatisticsDialog {...popup.get('data')} />);
registerPopup('betbook/infoDialog', popup => <BetbookInfoDialog {...popup.get('data')} />);

export default {
    HomePageBetbookPosts,
    BetbookRoot,
    BetbookLobby,
    BetbookPosts,
    BetbookPostsModule,
    EditorWithComments,
    MatchBetbookPosts
};
